module.exports = __webpack_public_path__ + "static/media/SFMono-SemiboldItalic.ca70ba8a.ttf";